import { useEffect, useRef } from 'react'
import { trackEvent } from '../../services/analytics'

type AdSensePlacement = 'home' | 'article'

declare global {
  interface Window {
    adsbygoogle?: Array<Record<string, never>>
  }
}

const client = (import.meta.env.VITE_ADSENSE_CLIENT || '').trim()
const enabled = import.meta.env.VITE_ADSENSE_ENABLED === 'true'
const complianceReady = import.meta.env.VITE_ADSENSE_COMPLIANCE_READY === 'true'

const slotByPlacement: Record<AdSensePlacement, string> = {
  home: (import.meta.env.VITE_ADSENSE_HOME_SLOT || '').trim(),
  article: (import.meta.env.VITE_ADSENSE_ARTICLE_SLOT || '').trim(),
}

export function AdSenseSlot({ placement }: { placement: AdSensePlacement }) {
  const requested = useRef(false)
  const slot = slotByPlacement[placement]
  const editorialHold = placement === 'article' && document.querySelector('meta[name="omikina-article-quality-hold"][content="true"]') !== null
  const ready = !editorialHold && enabled && complianceReady && /^ca-pub-\d+$/.test(client) && /^\d+$/.test(slot)

  useEffect(() => {
    if (!ready || requested.current) return
    requested.current = true
    try {
      // The account-level loader lives in index.html so Google can verify the
      // site even while manual placements remain gated behind compliance.
      window.adsbygoogle = window.adsbygoogle || []
      window.adsbygoogle.push({})
      trackEvent('ad_impression_request', { ad_platform: 'adsense', placement })
    } catch {
      requested.current = false
    }
  }, [placement, ready, slot])

  if (!ready) return null
  return <aside className={`adsense-slot adsense-slot--${placement}`} aria-label="Advertisement">
    <span>ADVERTISEMENTS</span>
    <ins
      className="adsbygoogle"
      style={{ display: 'block' }}
      data-ad-client={client}
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  </aside>
}
